import React from 'react';

import Chip from 'material-ui/Chip';
import theme from '../../muiTheme';
import './InfoBadge.css';

const InfoBadge = (props) => {

  return (
    <Chip
      className="chip-class"
      labelColor="white"
      onClick={props.onClick}
      backgroundColor={theme.palette.infoBadgeColor}
      labelStyle={{lineHeight: "21px"}}>
        <span style={{fontSize: "12px"}}>{props.label}</span>
    </Chip>
  );
}

export default InfoBadge;
